export function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}/${month}/${day}`;
}

export function formatearFecha(fecha) {
    if (!fecha) return "";

    const opciones = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    };

    return new Intl.DateTimeFormat('es-ES', opciones).format(fecha);
}

export function formatearFechaQueryString (date) {
    const month = date.getMonth() + 1;
    return date.getFullYear() + "-" + month.toString().padStart(2, "0") + "-" + date.getDate().toString().padStart(2, "0") + " " + date.getHours().toString().padStart(2, "0") +":"+date.getMinutes().toString().padStart(2, "0")+":00";
}
